
import React from "react";
import SSOLogin from "../views/sso/ssologin";
import LoginRoutes from "./LoginRoutes";

const SSOLoginRoutes=(props)=>{    
    return (
    <div>
      {(() => {
          if (window.localStorage.getItem("user") !== null) {
            return <SSOLogin/>       
          } else {
            return <LoginRoutes />
          }       
      })()}
    </div>
    );
}
export default SSOLoginRoutes;